const relatedContentsData = [
  {
    title:
      'Lenovo empowers the Data Center with technology, tools, and partnerships to build a smarter future for everyone.',
    content: 'article1',
    body: '',
    url: 'https://www.lenovo.com/us/en/servers-storage/',
    button: 'Explore Products and Services'
  },
  {
    title: 'Explore Smarter Infrastructure Customer Stories',
    content: 'article2',
    body: '',
    url: 'https://www.lenovo.com/us/en/servers-storage/smarter-infrastructure-stories/',
    button: 'Watch Now'
  },
  {
    title: 'Lenovo Tech World 2022: Watch the Full Event On-Demand',
    content: 'article3',
    body: '',
    url: 'https://techworld22.lenovo.com/',
    button: 'Get Started'
  },
  {
    title: 'Intel and Lenovo - Pioneering Together',
    content: 'article4',
    body: '',
    url: 'https://www.intel.com/content/www/us/en/partner/showcase/lenovo/overview.html',
    button: 'Learn More'
  }
];
const relatedContentsData2 = [
  {
    title: 'Lenovo Gives Wildlife Conservation an Edge',
    content: 'article5',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/LenovoIntel/Workforhumankind/',
    button: 'Read Article'
  },
  {
    title: 'Powering Perfect Produce with Lenovo and Intel',
    content: 'article6',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/LenovoIntel/perfection-fresh/',
    button: 'Read Article'
  }
  // {
  //   title: 'Houston Methodist Article TBD',
  //   content: 'article7',
  //   body: '',
  //   url: 'https://www.courageousstudios.com/',
  //   button: 'Read Article'
  // }
];

export { relatedContentsData, relatedContentsData2 };
